import {
  DeleteOutlined
} from '@ant-design/icons'
import {
  Button,
  Empty,
  Space,
  Spin,
  Tooltip,
} from 'antd'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import get from 'lodash.get'
import React, { useMemo, useState } from 'react'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { duplicatePostDelete, duplicatePostSellSearch } from '../../services/duplicate-post-service'
import ModalCustom from '../common/Modal/ModalCustom'
import { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import TableField from '../common/Table/TableField'
import { APARTMENT_TYPE, BALCONY_DIRECTION, FURNITURE_TYPE, LabelType, POLICY_DOCUMENT, PROCCESS_TRANFER, ProductType, SECURITY_TYPE, status, statusList } from './configs'
import { formatCurrencyLabel, getLabelByValue, hasPermission } from '../../config-func'
dayjs.extend(utc)
dayjs.extend(timezone)

const DuplicateSell = ({ item, isOpen, setIsOpen, getListPost, listDepartment, listProject }) => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })

  // const initialColumns = [
  //   {
  //     title: 'STT',
  //     dataIndex: 'stt',
  //     key: 'stt',
  //     fixed: 'left',
  //     width: 60,
  //     align: 'center',
  //     render: (_, __, index) =>
  //       (pagination.current - 1) * pagination.pageSize + index + 1
  //   },
  //   {
  //     title: 'ID',
  //     dataIndex: 'id',
  //     key: 'id',
  //     width: 60
  //   },
  //   {
  //     title: 'Nhu cầu',
  //     dataIndex: 'label',
  //     key: 'label',
  //     width: 90,
  //     render: (_, record) => (
  //       <span>
  //         {LabelType.find((n) => n.value === record.label)?.label || ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Hiện trạng',
  //     dataIndex: 'status',
  //     key: 'status',
  //     width: 120,
  //     render: (_, record) => (
  //       <span>
  //         {status.find((n) => n.value === record.status)?.label || ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Vị trí',
  //     dataIndex: 'apartment_location',
  //     key: 'apartment_location',
  //     width: 120,
  //     render: (_, record) => (
  //       <span>
  //         {APARTMENT_TYPE.find((n) => n.value === record.apartment_location)
  //           ?.label || record.apartment_location}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Hướng',
  //     dataIndex: 'direction',
  //     key: 'direction',
  //     width: 200,
  //     render: (_, record) => (
  //       <span>
  //         {BALCONY_DIRECTION.find((n) => n.value === record.direction)?.label ||
  //           ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Họ tên khách hàng',
  //     dataIndex: 'customer_name',
  //     key: 'customer_name',
  //     width: 200,
  //   },
  //   {
  //     title: 'Số điện thoại khách hàng',
  //     dataIndex: 'customer_phone_number',
  //     key: 'customer_phone_number',
  //     width: 400,
  //   },
  //   {
  //     title: 'Họ tên người đăng',
  //     dataIndex: 'name',
  //     key: 'name',
  //     width: 200,
  //     render: (_, record) => (
  //       <span>
  //         {record?.user_info?.name || ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Số điện thoại người đăng',
  //     dataIndex: 'phone',
  //     key: 'phone',
  //     width: 200,
  //     render: (_, record) => (
  //       <span>
  //         {record?.user_info?.phone || ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Ngày đăng',
  //     dataIndex: 'created_at',
  //     key: 'created_at',
  //     width: 150,
  //     render: (_, record) => (
  //       <span>
  //         {record?.created_at
  //           ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
  //           : ''}
  //       </span>
  //     )
  //   },
  //   {
  //     title: 'Hành động',
  //     key: 'status',
  //     fixed: 'right',
  //     align: 'center',
  //     width: 150,
  //     render: (_, record) => {
  //       return (
  //         <Space size="small">
  //           {hasPermission('P76.2', permissions) && (
  //               <Tooltip title="Xóa">
  //                 <Button
  //                   style={{ width: 32 }}
  //                   icon={<DeleteOutlined style={{ color: 'red' }} />}
  //                   onClick={() =>
  //                     showConfirm({
  //                       title: 'Xác nhận xoá',
  //                       content: (
  //                         <div>
  //                           Bạn có chắc chắn muốn xoá tin
  //                           <b> {record.title}</b> không?
  //                         </div>
  //                       ),
  //                       onOk: () => deletePost(record.id)
  //                     })
  //                   }
  //                 />
  //               </Tooltip>
  //           )}
  //         </Space>
  //       )
  //     }
  //   }
  // ]

  // Danh sách note
  
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 150,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.customer_phone_number}
          postId={record?.id}
        />
      )
    },
    // {
    //   title: 'Email',
    //   dataIndex: 'customer_email',
    //   key: 'customer_email'
    // },
    {
      title: 'Người đăng tin',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <span>{record?.user_info?.name}</span>
      }
    },
    {
      title: 'SĐT người đăng tin',
      dataIndex: 'phone',
      key: 'phone',
      width: 200,
      render: (_, record) => {
        return (
          <PhoneVisibilityCell
            value={record?.user_info?.phone}
            postId={record?.id}
          />
        )
      }
    },
    {
      title: 'Tên Sàn',
      dataIndex: 'department_id',
      key: 'department_id',
      width: 120,
      render: (_, record, index) => {
        const name = listDepartment.find(
          (n) => n.id === record.department_id
        )?.name
        return <span>{name}</span>
      }
    },
    {
      title: 'Quản lý tin',
      dataIndex: 'manager_post_id',
      key: 'manager_post_id',
      width: 150,
      // render: (text, record) => {
      //   const userIds = record.post_manager_info.map(
      //     (post) => post.manager_post_id
      //   )

      //   const names = listUserDepartment
      //     .filter((user) => userIds.includes(user.id))
      //     .map((user) => user.name)
      //     .join(', ')
      //   // getListUserPost(record.id)
      //   return <>{names}</>
      // }
      // render: (text) => <span>{'Ko biết'}</span>
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      width: 90,
      render: (_, record) => (
        <span>
          {LabelType.find((n) => n.value === record.label)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 150,
      render: (_, record) => (
        <span>
          {ProductType.find((n) => n.value === record.post_type)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>{getLabelByValue(record.type_real_estate)}</span>
      )
    },
    {
      title: 'Dự án',
      dataIndex: 'project_id',
      key: 'project_id',
      width: 200,
      render: (_, record) => (
        <span>
          {listProject.find((n) => n.id === record.project_id)?.project_name ||
            ''}
        </span>
      )
    },
    {
      title: 'Số địa chỉ',
      dataIndex: 'alley',
      key: 'alley',
      width: 150,
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 120,
    },
    {
      title: 'Toà',
      dataIndex: 'building',
      key: 'building',
      width: 100,
    },
    {
      title: 'Tầng',
      dataIndex: 'floor',
      key: 'floor',
      width: 80,
    },
    {
      title: 'Số căn',
      dataIndex: 'number_of_rooms',
      key: 'number_of_rooms',
      width: 80,
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 130,
    },
    {
      title: 'Số WC',
      dataIndex: 'number_of_wc',
      key: 'number_of_wc',
      width: 80,
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 130,
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 130,
    },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 120,
      render: (_, record) => (
        <span>
          {APARTMENT_TYPE.find((n) => n.value === record.apartment_location)
            ?.label || record.apartment_location}
        </span>
      )
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 120,
      render: (_, record) => (
        <span>
          {BALCONY_DIRECTION.find((n) => n.value === record.direction)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Nội thất',
      dataIndex: 'furniture',
      key: 'furniture',
      width: 120,
      render: (_, record) => (
        <span>
          {FURNITURE_TYPE.find((n) => n.value === record.furniture)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Giấy tờ pháp lý',
      dataIndex: 'legal',
      key: 'legal',
      width: 150,
      render: (_, record) => (
        <span>
          {POLICY_DOCUMENT.find((n) => n.value === record.legal)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Phí giao dịch',
      dataIndex: 'procedure',
      key: 'procedure',
      width: 150,
      render: (_, record) => (
        <span>
          {PROCCESS_TRANFER.find((n) => n.value === record.procedure)?.label ||
            ''}
        </span>
      )
    },

    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      width: 80,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Phí môi giới',
      dataIndex: 'cost',
      key: 'cost',
      width: 120,
      render: (_, record) => <span>{formatCurrencyLabel(record.cost)}</span>
    },
    {
      title: 'Hiện trạng',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (_, record) => (
        <span>
          {status.find((n) => n.value === record.status)?.label || ''}
        </span>
      )
    },
    {
      title: 'Trạng thái tin',
      dataIndex: 'processing_status',
      key: 'processing_status',
      width: 150,
      render: (_, record) => (
        <span>
          {statusList.find((n) => n.value === record.processing_status)?.label || ''}
        </span>
      )
    },

    {
      title: 'Bảo mật thông tin',
      dataIndex: 'security',
      key: 'security',
      width: 170,
      render: (_, record) => (
        <span>
          {SECURITY_TYPE.find((n) => n.value === record.security)?.label || ''}
        </span>
      )
    },   
    // {
    //   title: 'Note',
    //   dataIndex: 'note',
    //   key: 'note'
    // },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      width: 120,
    },
 
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.city_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.district_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_code',
      key: 'town_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.town_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 150,
    },
    {
      title: 'Email',
      width: 100,
      dataIndex: 'customer_email',
      key: 'customer_email'
    },

    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Thời gian cập nhật',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (_, record) => (
        <span>
          {record?.updated_at
            ? dayjs.unix(record?.updated_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
   
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {record.status !== 'inactive' &&
              hasPermission('P76.2', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá tin
                            <b> {record.title}</b> không?
                          </div>
                        ),
                        onOk: () => deletePost(record.id)
                      })
                    }
                  />
                </Tooltip>
              )}
          </Space>
        )
      }
    }
  ]
  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await duplicatePostSellSearch({
        duplicate_new: item.duplicate_new,
        label: 2,
        pageSize: pagination.pageSize
      })
      if (res?.data) {
        setDataSource(res?.data)
      } else {
        setDataSource([])
      }
      if(res?.data?.total === 0){
        getListPost();
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

    // Khi thay đổi trang
    const handlePageChange = (current, pageSize) => {
      setPagination((prev) => ({
        ...prev,
        current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
        pageSize
      }))
    }

    useMemo(() => {
      if (pagination.current && pagination.pageSize && isOpen) {
        fetchData({
          page: pagination.current,
          pageSize: pagination.pageSize
        })
      }
    }, [pagination.current, pagination.pageSize, isOpen])

// Xoá tin trùng bán
  const deletePost = async (ids) => {
    try {
      const body = {
        id: ids,
        from: 2
      }
      const res = await duplicatePostDelete(body)
      fetchData()
      setSelectedRowKeys([])
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  return (
    <ModalCustom
      title="Danh sách tin trùng bán "
      visible={isOpen}
      centered
      width={1200}
      // className="modal-bond"
      onCancel={() => {
        setIsOpen(false)
      }}
      cancelText="Đóng"
      
    >
     {!loading && (
         <div
         style={{
           display: 'flex',
           justifyContent: 'flex-start',
           alignItems: 'center',
           margin: '0px 0px 20px 0px',
           width: '100%'
         }}
       >
     {/* {hasPermission('P76.2', permissions)  */}
     {dataSource?.list?.length > 0 && hasPermission('P76.2', permissions) && (
             <Button
               danger
               type="primary"
               onClick={() => {
                 if (selectedRowKeys.length == 0) {
                   openNotification('error', 'Vui lòng chọn tin')
                 } else {
                   showConfirm({
                     title: 'Xác nhận xoá',
                     content: (
                       <div>
                         Bạn có chắc chắn muốn xoá{' '}
                         <b>{selectedRowKeys?.length}</b> tin không?
                       </div>
                     ),
                     onOk: () => deletePost(selectedRowKeys)
                   })
                 }
               }}
             >
               <DeleteOutlined />
              {selectedRowKeys?.length ? `Xoá ${selectedRowKeys?.length} tin` : 'Xoá'}
             </Button>
     )}
             </div>
      )}
      {loading ? <div style={{ maxWidth: '100%', margin: 'auto', padding: '10px 26px', display: 'flex', justifyContent: 'center' }}><Spin /></div> : (
        dataSource?.list?.length > 0 ? (
          <TableField
          loading={loading}
          columns={initialColumns}
          data={dataSource?.list}
          scroll={{ x: dataSource?.list?.length > 0 ? 'max-content' : '100%', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: dataSource?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
        ) : (
          <div style={{ maxWidth: '100%', margin: 'auto', padding: '10px 26px', display: 'flex', justifyContent: 'center' }}>
            <p>Không có dữ liệu</p>
          </div>
        )
      )}
    </ModalCustom>
  )
}

export default DuplicateSell
